import React, { useState } from 'react';
import CircleButton, {
  getCircleButtonClass,
} from 'components/v2/buttons/CircleButton';
import { ClipboardIcon } from '@heroicons/react/24/solid';
import CheckIcon from 'components/v2/icons/CheckIcon';
import { useTranslation } from 'react-i18next';
import EditReferenceNumbersModal from 'components/modules/shipments/EditReferenceNumbersModal';
import ShipmentsActionCreators from 'actions/ShipmentsActionCreators';
import { isIntermodalShipmentType } from 'helpers/shipment-types';

export default function ReferenceNumbersNextStep({ item, shipment }) {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);

  const isIntermodal = isIntermodalShipmentType(shipment);

  const renderIcon = () => {
    return !item.complete ? (
      <ClipboardIcon type="solid" className="w-5 h-5" />
    ) : (
      <div
        data-testid="div-16940b5e"
        className={getCircleButtonClass({ size: 'small', color: 'brand' })}>
        <CheckIcon />
      </div>
    );
  };

  const handleSave = (referenceNumbers, updatedRefEvents = []) => {
    ShipmentsActionCreators.updateReferenceNumbers(
      shipment,
      referenceNumbers,
      updatedRefEvents,
    );
    setShowModal(false);
  };

  return (
    (<div data-testid="div-5b8f4d6a">
      <div
        data-testid="div-c0bc3155"
        className="flex justify-between text-sm text-gray-700  py-1 items-center">
        <span data-testid="span-37265a53">{t('PROVIDE_REFERENCE_NUMBERS')}</span>

        <CircleButton
          dataTestId="CircleButton-af807905"
          size="small"
          disabled={item.complete}
          onClick={() => setShowModal(true)}>
          {renderIcon()}
        </CircleButton>
      </div>
      <EditReferenceNumbersModal
        show={showModal}
        reference_numbers={shipment.reference_numbers}
        onSave={handleSave}
        onClose={() => setShowModal(false)}
        isIntermodalShipmentType={isIntermodal}
        page="NextSteps"
        shipper={shipment.shipper}
        requiredReferenceNumbers={shipment?.missingReferenceNumbersList}
      />
    </div>)
  );
}
